'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatReclineNormal = function MdAirlineSeatReclineNormal(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 33.4l-2.5 2.5-5.8-5.9h-8.5q-2 0-3.5-1.5t-1.5-3.5v-9.6q0-1.5 1.2-2.6t2.6-1.2h0.1q1.5 0 2.7 1.3l2.4 2.6q1.3 1.5 3.5 2.4t4.3 0.9v3.7q-4.9 0-9.3-3.7v6.2h5.8z m-23.4-6.8q0 2.1 1.5 3.6t3.5 1.4h10v3.4h-10q-3.4 0-5.9-2.5t-2.5-5.9v-15h3.4v15z m2.7-17.6q-1.1-1-1.1-2.4t1.1-2.3 2.3-1 2.3 1 1.1 2.3-1.1 2.4-2.3 1-2.3-1z' })
        )
    );
};

exports.default = MdAirlineSeatReclineNormal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-recline-normal.js
// module id = 3046
// module chunks = 168707334958949